<script lang="ts">
    import src from './svg/stylus_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    import IconStylus from './IconStylus.svelte';
    import WhiteColor from '../WhiteColor.svelte';

    export let scale: number = 0.5;
</script>

<div class="round-background">
    <WhiteColor>
        <IconStylus {scale} on:click />
    </WhiteColor>
</div>

<style>
    .round-background {
        background-color: #1c5dc7;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translate(-5px, -10px);
    }
    :global(.icon) {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
